import styled from 'styled-components'
import { Swiper } from 'swiper/react'

export const Section = styled.section`
  background: ${({ theme }) => theme.colors.boxBackground};
  padding: 2.8rem 0;

  @media screen and (min-width: 768px) {
    padding: 0;
  }
`

export const Title = styled.div`
  margin: 0 auto;
  width: fit-content;
  text-align: center;
  padding: 2rem 0 4rem;

  @media screen and (min-width: 768px) {
    padding: 4.5rem 0 3.5rem;
  }
`

export const Slider = styled(Swiper)`
  .swiper-slide {
    aspect-ratio: 1;

    /* This is a workaround to make slides 200px wide on mobile and not setting a width on desktop with important rule */
    @media screen and (max-width: 767px) {
      width: 200px !important;
    }
  }
`

export const Anchor = styled.a`
  display: block;
  width: 100%;
  height: 100%;

  .safari-lower-than-15 & {
    padding-top: 100%;
    position: relative;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
  }
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;

  .safari-lower-than-15 & {
    position: absolute;
    top: 0;
  }
`
